<script>
import { Line } from 'vue-chartjs'

export default {
  name: 'LineChart',
  extends: Line,
  data () {
    return {
      options: {
        legend: {
          display: false
        }
      },
      chart: {
        labels: [],
        datasets: [
          {
            backgroundColor: '#f87979',
            data: []
          },
        ]
      }
    }
  },
  mounted() {
    // Overwriting base render method with actual data.
    this.init()
  },
  methods: {
    init() {
      this.chart.labels = this.chartlabel
      this.chart.datasets[0].data = this.chartdata
      this.renderChart(this.chart, this.options)
    }
  },
  props: ['chartlabel', 'chartdata'],
  watch: {
    'chartdata': function () {
      this.init()
    }
  }
}
</script>

<style></style>
